import type { MonospaceAuditLog } from '#layers/data-model/types/schema/resolved-schema';
import { RStoreSchema } from '#imports';
import { Project } from './project';
import { User } from './user';

export const AuditLog = RStoreSchema.withItemType<MonospaceAuditLog>().defineCollection({
	name: 'DirectusAuditLog',
	scopeId: 'monospace-default',
	meta: {
		defaultFields: [
			'id',
			'timestamp',
			'action',
			'resourceType',
			'resourceId',
			'actorId',
			'actorIp',
			'outcome',
			'collectionId',
			'projectId',
		],
		endpoint: 'system/audit-logs',
	},
});

export const AuditLogRelations = RStoreSchema.defineRelations(AuditLog, ({ collection }) => ({
	actor: {
		to: collection(User, {
			on: {
				'MonospaceUser.id': 'DirectusAuditLog.actorId',
			},
		}),
	},
	project: {
		to: collection(Project, {
			on: {
				'MonospaceProject.id': 'DirectusAuditLog.projectId',
			},
		}),
	},
}));
